import { render } from "./msg.vue?vue&type=template&id=17d9ecd5&scoped=true"
import script from "./msg.vue?vue&type=script&lang=js"
export * from "./msg.vue?vue&type=script&lang=js"

import "./msg.vue?vue&type=style&index=0&id=17d9ecd5&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d9ecd5"]])

export default __exports__